import { USER_VERIFICATION_ACTIONS } from './../../constants/actions';

export const setUserVerificationEmailSent = (value: boolean) => ({
  type: USER_VERIFICATION_ACTIONS.SET_EMAIL_SENT,
  emailSent: value,
});
